import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProcedureService } from '@/app/components/tramites/procedure.service';
import {
  canDownloadOutput,
  citizenDisplayStatus,
  getRequestAction,
  statusCssClass,
} from '@/app/shared/utils/procedure-request-status.util';

@Component({
  selector: 'app-list-tramites',
  templateUrl: './list-tramites.component.html',
  styleUrls: [
    './list-tramites.component.scss',
    '../../../catalogs/ver-tramite/ver-tramite.component.scss'
  ]
})
export class ListTramitesComponent implements OnInit, OnDestroy {

  @Input() id: string;
  @Input() location: string;

  public data: any[] = [];
  private subs: Subscription[] = [];

  isLoading    = false;
  page         = 1;
  pageSize     = 10;
  totalRecords = 0;
  totalPages   = 0;
  downloadingId: string | null = null;

  constructor(private procedureService: ProcedureService) {}

  ngOnInit(): void {
    this.loadTramites();
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  loadTramites(): void {
    if (!this.id) return;
    this.isLoading = true;
    const offset = (this.page - 1) * this.pageSize;

    this.subs.push(
      this.procedureService.listRequestsByUser(this.id, { limit: this.pageSize, offset })
        .subscribe({
          next: (res) => {
            this.data         = Array.isArray(res.rows) ? res.rows : [];
            this.totalRecords  = res.total || this.data.length;
            this.totalPages    = Math.ceil(this.totalRecords / this.pageSize);
            this.isLoading     = false;
          },
          error: (err) => {
            console.error('Error al cargar trámites:', err);
            this.data         = [];
            this.totalRecords  = 0;
            this.totalPages    = 0;
            this.isLoading     = false;
          }
        })
    );
  }

  loadPage(page: number): void {
    this.page = page;
    this.loadTramites();
  }

  get hasData(): boolean {
    return this.data.length > 0;
  }

  displayStatus(status: string): string {
    return citizenDisplayStatus(status);
  }

  statusClass(status: string): Record<string, boolean> {
    const cls = statusCssClass(status);
    return { [cls]: true };
  }

  getAction(req: any) {
    return getRequestAction(req?.Status);
  }

  canDownload(req: any): boolean {
    const docId = req?.OutputDocumentId || req?.OutputDocument?.id;
    return canDownloadOutput(req?.Status, docId);
  }

  formLink(req: any): any[] {
    const slug = req?.Procedure?.Slug;
    if (!slug) return ['/ciudadano/tramites'];
    return ['/ciudadano/tramites', slug, 'iniciar'];
  }

  formQueryParams(req: any): Record<string, string> {
    const params: Record<string, string> = { requestId: req.id };
    const action = this.getAction(req);
    if (action?.type === 'view') {
      params.mode = 'view';
    }
    return params;
  }

  downloadOutput(req: any, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const docId = req?.OutputDocumentId || req?.OutputDocument?.id;
    if (!docId || this.downloadingId) return;

    this.downloadingId = req.id;
    this.procedureService.viewDocument(req.id, docId).subscribe({
      next: (blob) => {
        const name = req?.OutputDocument?.FileName || `documento-${req.Folio || req.id}.pdf`;
        const url  = window.URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
        this.downloadingId = null;
      },
      error: () => {
        this.downloadingId = null;
      },
    });
  }
}
